import { render, staticRenderFns } from "./BookCusList.vue?vue&type=template&id=243332e6"
import script from "./BookCusList.vue?vue&type=script&lang=js"
export * from "./BookCusList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports